const historialInventarioEnumerators = {
  tipoUbicacion: ['Responsable', 'Ubicacion'],
  tipoMovimiento: ['Responsable', 'Ubicacion'],
};

export default historialInventarioEnumerators;
